(() => {
  const enhance = () => {
    document.querySelectorAll('.productView-thumbnail-wrapper').forEach(wrapper => {
      const thumbs = wrapper.querySelectorAll('.productView-thumbnail:not(.slick-cloned)');
      wrapper.classList.toggle('sop-single-media', thumbs.length === 1);
    });
    document.querySelectorAll('[data-sidebar],.toolbar-filter,.toolbar-sort,.toolbar .icon-mode').forEach(control => {
      if (control.matches('a,button,input,select,textarea') || control.querySelector('button,a,input,select,textarea')) return;
      if (!control.hasAttribute('data-sop-keyboard')) {
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.setAttribute('data-sop-keyboard', 'true');
        control.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); control.click(); }
        });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
